<template>
    <div class="module">
        <ScrollList class="service" :items="items" :cols="4">
            <template v-slot:default="{card}">
                <h4>{{card.name}}</h4>
                <b-card-text class="desc" :title="card.desc" v-html="card.desc">
                </b-card-text>
            </template>
        </ScrollList>
    </div>
</template>

<script>
    import ScrollList from '../../common/ScrollList'

    export default {
        name: 'List',
        props: {
            items: Array,
        },
        components: {
            ScrollList,
        },
    }
</script>

<style lang="less" scoped>
    .en {
        .module /deep/ h4 {
            font-size: 18px !important;
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
        }

        .module /deep/ .card-text {
            font-size: 16px !important;
        }
    }

    .module /deep/ .list {
        margin-top: 0;
        .list-item {
            flex-wrap: wrap;

            .col {
                &:nth-child(n+4) {
                    margin-top: 30px;
                }

                img {
                    cursor: auto;
                }
            }
        }
    }

    .module /deep/ h4 {
        margin-top: 12px;
        margin-bottom: 15px;
        font-size: 18px;
        line-height: 27px;
        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
    }

    .module /deep/ .desc {
        margin-bottom: 30px !important;
        font-size: 14px;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: justify;
    }

    .service {
        /deep/ .card-body {
            text-align: center;

            p {
                margin: 0;
                font-size: 14px;
                line-height: 28px;
                text-align: center;

                a {
                    color: #000;
                    cursor: pointer;
                    text-decoration: underline;

                }
            }
        }
    }
</style>
